import { render, staticRenderFns } from "./MagliaOrFlagPlusNome.vue?vue&type=template&id=290e33f7&scoped=true&"
import script from "./MagliaOrFlagPlusNome.vue?vue&type=script&lang=js&"
export * from "./MagliaOrFlagPlusNome.vue?vue&type=script&lang=js&"
import style0 from "./MagliaOrFlagPlusNome.vue?vue&type=style&index=0&id=290e33f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e33f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('290e33f7')) {
      api.createRecord('290e33f7', component.options)
    } else {
      api.reload('290e33f7', component.options)
    }
    module.hot.accept("./MagliaOrFlagPlusNome.vue?vue&type=template&id=290e33f7&scoped=true&", function () {
      api.rerender('290e33f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/MagliaOrFlagPlusNome.vue"
export default component.exports